import type { Team, Dog, Hunt, Device } from '@wehunt/ui'

export const SAMPLE_USER = {
  name: "Klas Lindqvist",
  email: "klas.lindqvist@wehunt.se",
  avatar: "KL",
}

export const SAMPLE_TEAMS: Team[] = [
  {
    id: "t1",
    name: "ANGERMANLAND",
    role: "admin",
    members: 12,
    area: "Angermanland",
    hectares: 3420,
    nextHunt: "Sat Apr 26, 07:00",
    joinCode: "ANG001",
    photo: "team-photo-3.jpg",
    map: {
      name: "North parcel",
      borderColor: "#3E68FF",
      updated: "2 days ago",
      boundaryAreas: [
        { id: 'b1', name: '', rings: [[
          { lat: 63.3352, lon: 17.7348 },
          { lat: 63.3417, lon: 17.8219 },
          { lat: 63.3352, lon: 17.9236 },
          { lat: 63.3156, lon: 17.9962 },
          { lat: 63.2765, lon: 18.0252 },
          { lat: 63.2309, lon: 18.0107 },
          { lat: 63.1983, lon: 17.9526 },
          { lat: 63.1918, lon: 17.8510 },
          { lat: 63.2048, lon: 17.7638 },
          { lat: 63.2439, lon: 17.7203 },
          { lat: 63.2961, lon: 17.7203 },
        ]]},
      ],
      objects: [
        { id: "o1", type: "tower",  lat: 63.3026, lon: 17.8001, label: "Stand 1 – North edge" },
        { id: "o2", type: "tower",  lat: 63.2896, lon: 17.8945, label: "Stand 2 – The marsh" },
        { id: "o3", type: "tower",  lat: 63.2504, lon: 17.8510, label: "Stand 3 – Clearing" },
        { id: "o4", type: "tower",  lat: 63.2374, lon: 17.9526, label: "Stand 4 – The bend" },
        { id: "o5", type: "pin",    lat: 63.2765, lon: 17.8292, label: "Moose trail", kind: "track" },
        { id: "o6", type: "pin",    lat: 63.2635, lon: 17.9236, label: "Salt lick", kind: "salt" },
        { id: "o7", type: "pin",    lat: 63.2276, lon: 17.7784, label: "Parking", kind: "parking" },
        { id: "o8", type: "camera", lat: 63.3091, lon: 17.8800, label: "Burrel 01" },
        { id: "o9", type: "camera", lat: 63.2700, lon: 17.9816, label: "Burrel 02" },
      ],
      subAreaPolygons: [
        { id: "sa1", name: "North drive", rings: [[
          { lat: 63.3156, lon: 17.7711 },
          { lat: 63.3222, lon: 17.8800 },
          { lat: 63.2830, lon: 17.9091 },
          { lat: 63.2765, lon: 17.8219 },
          { lat: 63.2896, lon: 17.7638 },
        ]]},
      ],
      forbiddenPolygons: [
        { id: "fa1", name: "Farmstead", rings: [[
          { lat: 63.2504, lon: 17.9381 },
          { lat: 63.2567, lon: 17.9962 },
          { lat: 63.2309, lon: 18.0034 },
          { lat: 63.2243, lon: 17.9526 },
        ]]},
      ],
    },
  },
  {
    id: "t2",
    name: "Kalix Moose Hunt",
    role: "member",
    members: 8,
    area: "Norrbotten",
    hectares: 5780,
    nextHunt: "Sun Apr 27, 06:30",
    joinCode: "KAL002",
    photo: "team-photo-2.jpg",
    map: {
      name: "Kalix river west",
      updated: "3 days ago",
      boundaryAreas: [
        { id: 'b1', name: '', rings: [[
          { lat: 63.3287, lon: 17.7493 },
          { lat: 63.3417, lon: 17.8800 },
          { lat: 63.3222, lon: 17.9962 },
          { lat: 63.2635, lon: 18.0252 },
          { lat: 63.2178, lon: 17.9816 },
          { lat: 63.2048, lon: 17.8655 },
          { lat: 63.2178, lon: 17.7638 },
          { lat: 63.2635, lon: 17.7203 },
          { lat: 63.3026, lon: 17.7203 },
        ]]},
      ],
      objects: [
        { id: "o10", type: "tower",  lat: 63.2961, lon: 17.8074, label: "River pass" },
        { id: "o11", type: "tower",  lat: 63.2765, lon: 17.9091, label: "South hill" },
        { id: "o12", type: "pin",    lat: 63.2439, lon: 17.8655, label: "Blood trail", kind: "track" },
        { id: "o13", type: "pin",    lat: 63.3026, lon: 17.9671, label: "Parking", kind: "parking" },
        { id: "o14", type: "camera", lat: 63.2830, lon: 17.8510, label: "Game cam" },
      ],
    },
  },
  {
    id: "t3",
    name: "Smaland Wild Boar",
    role: "member",
    members: 6,
    area: "Kronoberg",
    hectares: 1890,
    nextHunt: "Fri May 2, 19:00",
    joinCode: "SML003",
    photo: "team-photo-1.jpg",
    map: {
      name: "Field & forest",
      updated: "1 day ago",
      boundaryAreas: [
        { id: 'b1', name: '', rings: [[
          { lat: 63.3222, lon: 17.7638 },
          { lat: 63.3352, lon: 17.9091 },
          { lat: 63.3091, lon: 17.9962 },
          { lat: 63.2635, lon: 18.0107 },
          { lat: 63.2243, lon: 17.9526 },
          { lat: 63.2178, lon: 17.8219 },
          { lat: 63.2504, lon: 17.7493 },
          { lat: 63.2896, lon: 17.7348 },
        ]]},
      ],
      objects: [
        { id: "o15", type: "tower",  lat: 63.2961, lon: 17.8364, label: "North bait" },
        { id: "o16", type: "tower",  lat: 63.2700, lon: 17.9381, label: "South bait" },
        { id: "o17", type: "pin",    lat: 63.2504, lon: 17.8800, label: "Bait site", kind: "bait" },
        { id: "o18", type: "camera", lat: 63.2896, lon: 17.8945, label: "Boar cam" },
      ],
    },
  },
]

export const SAMPLE_DOGS: Dog[] = [
  { id: "d1", name: "Aksel", breed: "Drever",             age: 5, gender: "Male",   team: "ANGERMANLAND",     deviceId: "dev-01", color: "#6b4423", status: "tracking" },
  { id: "d2", name: "Freja", breed: "Jamthund",           age: 3, gender: "Female", team: "ANGERMANLAND",     deviceId: "dev-02", color: "#8a6d3a", status: "idle" },
  { id: "d3", name: "Bjorn", breed: "Norwegian Elkhound", age: 7, gender: "Male",   team: "Kalix Moose Hunt", deviceId: "dev-03", color: "#3a3a3a", status: "tracking" },
  { id: "d4", name: "Saga",  breed: "Finnish Hound",      age: 2, gender: "Female", team: "Smaland Wild Boar", deviceId: null,    color: "#c9a572", status: "idle" },
]

const _huntsToday = new Date()
const _isoOffset = (offsetDays: number) => {
  const d = new Date(_huntsToday.getFullYear(), _huntsToday.getMonth(), _huntsToday.getDate() + offsetDays)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`
}

export const SAMPLE_HUNTS: Hunt[] = [
  // Past
  { id: "h1",  date: _isoOffset(-42), start: "06:30", end: "14:00", team: "ANGERMANLAND",     teamId: "t1", quarry: "Moose",     location: "North parcel",     participants: 9, dogs: ["Aksel", "Freja"], status: "ended", harvest: [{ species: "Moose", count: 1, note: "Young bull" }] },
  { id: "h2",  date: _isoOffset(-35), start: "07:00", end: "12:30", team: "ANGERMANLAND",     teamId: "t1", quarry: "Moose",     location: "North parcel",     participants: 8, dogs: ["Aksel"],          status: "ended", harvest: [] },
  { id: "h3",  date: _isoOffset(-28), start: "06:00", end: "15:00", team: "Kalix Moose Hunt", teamId: "t2", quarry: "Moose",     location: "Kalix river west", participants: 7, dogs: ["Bjorn"],          status: "ended", harvest: [{ species: "Moose", count: 2, note: "Cow and calf" }] },
  { id: "h4",  date: _isoOffset(-21), start: "19:00", end: "23:00", team: "Smaland Wild Boar", teamId: "t3", quarry: "Wild boar", location: "Field & forest",   participants: 5, dogs: ["Saga"],           status: "ended", harvest: [{ species: "Wild boar", count: 3, note: "Sounder in the rape field" }] },
  { id: "h5",  date: _isoOffset(-14), start: "07:30", end: "13:00", team: "ANGERMANLAND",     teamId: "t1", quarry: "Roe deer",  location: "North parcel",     participants: 6, dogs: ["Freja"],          status: "ended", harvest: [{ species: "Roe deer", count: 1, note: "Buck, clean shot" }] },
  { id: "h6",  date: _isoOffset(-7),  start: "06:30", end: "11:30", team: "Smaland Wild Boar", teamId: "t3", quarry: "Wild boar", location: "Field & forest",   participants: 4, dogs: ["Saga"],           status: "ended", harvest: [] },
  { id: "h7",  date: _isoOffset(-3),  start: "20:00", end: "23:30", team: "Smaland Wild Boar", teamId: "t3", quarry: "Wild boar", location: "Field & forest",   participants: 5, dogs: [],                 status: "ended", harvest: [{ species: "Wild boar", count: 1, note: "Solo boar, 85 kg" }] },
  { id: "h8",  date: _isoOffset(-1),  start: "06:00", end: "12:00", team: "Kalix Moose Hunt", teamId: "t2", quarry: "Moose",     location: "Kalix river west", participants: 7, dogs: ["Bjorn"],          status: "ended", harvest: [] },

  // Upcoming
  { id: "h9",  date: _isoOffset(2),   start: "07:00", end: "13:00", team: "ANGERMANLAND",     teamId: "t1", quarry: "Moose",     location: "North parcel",     participants: 10, dogs: ["Aksel", "Freja"], status: "upcoming", myRsvp: "pending",  invitedBy: "Anders Jarl" },
  { id: "h10", date: _isoOffset(3),   start: "06:30", end: "14:00", team: "ANGERMANLAND",     teamId: "t1", quarry: "Moose",     location: "North parcel",     participants: 9,  dogs: ["Aksel"],          status: "upcoming", myRsvp: "accepted" },
  { id: "h11", date: _isoOffset(4),   start: "06:00", end: "15:00", team: "Kalix Moose Hunt", teamId: "t2", quarry: "Moose",     location: "Kalix river west", participants: 8,  dogs: ["Bjorn"],          status: "upcoming", myRsvp: "pending",  invitedBy: "Petra Lundgren" },
  { id: "h12", date: _isoOffset(9),   start: "19:00", end: "23:00", team: "Smaland Wild Boar", teamId: "t3", quarry: "Wild boar", location: "Field & forest",   participants: 6,  dogs: ["Saga"],           status: "upcoming", myRsvp: "accepted" },
  { id: "h13", date: _isoOffset(14),  start: "07:00", end: "12:00", team: "ANGERMANLAND",     teamId: "t1", quarry: "Roe deer",  location: "North parcel",     participants: 5,  dogs: ["Freja"],          status: "upcoming", myRsvp: "pending",  invitedBy: "Anna Sjoberg" },
  { id: "h14", date: _isoOffset(17),  start: "06:30", end: "13:00", team: "Kalix Moose Hunt", teamId: "t2", quarry: "Moose",     location: "Kalix river west", participants: 8,  dogs: ["Bjorn"],          status: "upcoming", myRsvp: "accepted" },
  { id: "h15", date: _isoOffset(24),  start: "20:00", end: "23:30", team: "Smaland Wild Boar", teamId: "t3", quarry: "Wild boar", location: "Field & forest",   participants: 5,  dogs: ["Saga"],           status: "upcoming", myRsvp: "declined" },

  // Drafts
  { id: "h-d1", date: _isoOffset(11), start: "07:00", end: "13:00", team: "ANGERMANLAND",     teamId: "t1", quarry: "Moose",    location: "South ridge", participants: 0, dogs: [], status: "draft", draftStep: "Drives" },
  { id: "h-d2", date: _isoOffset(20), start: "06:00", end: "12:00", team: "Kalix Moose Hunt", teamId: "t2", quarry: "Roe deer", location: "—",           participants: 0, dogs: [], status: "draft", draftStep: "Participants" },
]

export const SAMPLE_DEVICES: Device[] = [
  { id: "dev-01", name: "Tracker R1",    model: "WeHunt GPS Tracker R1", serial: "WH-R1-8842-KL", battery: 78, signal: 4, paired: "Aksel", firmware: "2.8.4", lastSeen: "5 min ago" },
  { id: "dev-02", name: "Tracker R1",    model: "WeHunt GPS Tracker R1", serial: "WH-R1-9921-PM", battery: 45, signal: 3, paired: "Freja", firmware: "2.8.4", lastSeen: "12 min ago" },
  { id: "dev-03", name: "Tracker Pro",   model: "WeHunt GPS Pro",        serial: "WH-PR-1204-XT", battery: 92, signal: 5, paired: "Bjorn", firmware: "3.1.0", lastSeen: "just now" },
  { id: "dev-04", name: "Burrel Camera", model: "Burrel S22 Trail Cam",  serial: "BR-S22-4471-GH", battery: 64, signal: 3, paired: null,    firmware: "1.4.2", lastSeen: "2 hrs ago" },
  { id: "dev-05", name: "Tracker R1",    model: "WeHunt GPS Tracker R1", serial: "WH-R1-0118-NV", battery: 12, signal: 2, paired: null,    firmware: "2.7.1", lastSeen: "3 days ago" },
]
